import type { SlotLook } from "./materials/slotLook";

export const DRAG_THRESHOLD_PIXELS = 5;
export const CLIP_FADE_SECONDS = 0.2;
export const SQUARE_UNITS = 1;
export const MOVE_DURATION_SECONDS_PER_UNIT = 0.25;
export const ROTATION_DURATION_SECONDS = 0.25;
export const ATTACK_DURATION_SECONDS = 0.5;
export const DEFAULT_BLOOM_STRENGTH = 1.2;
export const DEFAULT_OUTLINE_COLOR = 0xffcc00;
export const DEFAULT_OUTLINE_EDGE_STRENGTH = 8;

export const ORIGINAL_LOOK: SlotLook = { mode: "original" };
